import React, { ReactNode } from 'react';
import { Link } from 'gatsby';
import Header from '../header';
import Footer from '../footer';
// import Header from "../common/Header";
// import "./index.scss";

interface Props {
  children?: ReactNode;
  location?: Location;
  title?: string;
  // any props that come into the component
}

const Layout = ({ children }: Props) => {
  return (
    <div className="global-wrapper">
      <Header />
      <main className="global-main">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
